import React, { useState } from 'react'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import FormAddFence from '../../Geofences/formAddFence'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

export default function ModalFence ({ onClose, type, onClick, show, title, buttonLabel, data, unitArea, setUnitArea }) {
  // console.log(props);
  const { t } = useTranslation('geofences')
  const [fenceData, setFenceData] = useState(null)
  const idFence = type === 'edit' ? data?.id : null

  return (
    <Modal
      show={show}
      className="modal-content-geofences"
      size="xl"
      onHide={type === 'add'
        ? () => onClose('create')
        : () => onClose('edit')
        // props.clearInputs()
      }
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {type === 'add'
          ? (
          <FormAddFence setFenceData={setFenceData} type={type} unitArea={unitArea} setUnitArea={setUnitArea}/>
            )
          : (
          <FormAddFence setFenceData={setFenceData} fenceData={data} type={type} unitArea={unitArea} setUnitArea={setUnitArea}/>
            )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={type === 'add'
            ? () => onClose('create')
            : () => onClose('edit')
          }
          variant="danger">
          {t('modalFence.button3')}
        </Button>
        <Button
          onClick={() => onClick(fenceData, type, idFence, unitArea)}
          variant="primary"
          id="btnModalFence"
        >
          {buttonLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

ModalFence.propTypes = {
  onClick: PropTypes.func,
  type: PropTypes.string,
  onClose: PropTypes.func,
  show: PropTypes.func,
  title: PropTypes.string,
  buttonLabel: PropTypes.string,
  data: PropTypes.array,
  unitArea: PropTypes.string,
  setUnitArea: PropTypes.func
}
